import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'

import { Button } from '@components/Button'
import { Modal, ModalHeader, ModalContent } from '@components/Modal/index'
import { GenericErrorModal } from '@components/Modal/GenericErrorModal'

export const TalkToAWealthManagerModal = ({ open, scenarioImplemented, onClose, onAccept }) => {
  const [talkToAWealthManager, setTalkToAWealthManager] = useState(false)
  const [requestSent, setRequestSent] = useState(false)
  const [error, setError] = useState(false)

  const onTalkToAWealthManager = async () => {
    setRequestSent(true)
    const response = await onAccept()
    if (response.ok) {
      setTalkToAWealthManager(true)
    } else {
      setError(true)
    }
  }

  if (error) {
    return ( <GenericErrorModal open={open} close={onClose} /> )
  }

  return (
    <Modal small open={open} onClose={onClose}>
      { talkToAWealthManager
        ? <CongratulationsView onClose={onClose} scenarioImplemented={scenarioImplemented} />
        : <TalkToAWealthManagerView
            requestSent={requestSent}
            scenarioImplemented={scenarioImplemented}
            onClose={onClose}
            onTalkToAWealthManager={onTalkToAWealthManager} />
      }
    </Modal>
  )
}

const TalkToAWealthManagerView = ({ scenarioImplemented, onClose, onTalkToAWealthManager, requestSent }) => {
  return (
    <>
      <ModalHeader>Talk to an advisor</ModalHeader>
      <ModalContent className='centered'>
        <h5 className='text-center'>{
          scenarioImplemented ?
            "Get some peace of mind by having an expert review your plan. They can also help co-plan any future scenarios." :
            "Now that you've created your new scenario, you can have a professional review your plan and implement it with you."
        }</h5>
        <Box
          display='flex'
          justifyContent='center'
          flexDirection='column'
        >
          <Box mb='1rem' display='flex' justifyContent='center'>
            <Button disabled={requestSent} primary onClick={onTalkToAWealthManager} trackAs={'Request Advisor: Send Request'}>
              { requestSent ? 'Sending your request...' :'Talk to an advisor' }
            </Button>
          </Box>
          <small className='text-center'>By requesting to talk to an advisor you agree to share your profile with an advisor and have them contact you</small>
          <Box mt='2rem' display='flex' justifyContent='center'>
            <Button className='text-link' onClick={onClose} trackAs={'Request Advisor: Maybe Later'}>
              Maybe later
            </Button>
          </Box>
        </Box>
      </ModalContent>
    </>
  )
}

const CongratulationsView = ({ onClose, scenarioImplemented }) =>
  <>
    <ModalHeader>Fantastic! You will be contacted shortly.</ModalHeader>
    <ModalContent className='centered'>
      <h5 className='text-center'>We've passed your profile along and you should hearing from an advisor soon.</h5>
      <Box
        display='flex'
        justifyContent='center'
        flexDirection='column'
      >
        <Box fontSize='5rem' textAlign='center'>
          🥳
        </Box>
        <Box mb='1rem' display='flex' justifyContent='center'>
          <Button primary onClick={onClose}>Take me to my {scenarioImplemented ? 'dashboard' : 'scenario'}</Button>
        </Box>
      </Box>
    </ModalContent>
  </>

TalkToAWealthManagerModal.propTypes = {
  /** Signifies if the modal is open */
  open: PropTypes.bool.isRequired,
  /** Function to call to close the modal */
  onClose: PropTypes.func.isRequired,
  /** Whether the current scenario is implemented or not */
  scenarioImplemented: PropTypes.bool.isRequired,
  /** Function to call when the CTA is clicked. This function returns a promise
   *  with the content of the response. */
  onAccept: PropTypes.func.isRequired
}
